import React from 'react';

import classNames from 'classnames';

import A from 'wanderu-component-react-router-link';
import {
    MarkdownContent,
    PageSection,
    SectionTitle,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import {
    FOUNDER_DATA,
    LINKEDIN_LOGO_URL,
    TWITTER_LOGO_URL,
} from '../../constants';

import styles from './FoundersSection.scss';

function SocialMediaTag(props) {
    const {
        className,
        label,
        linkedInUrl,
        twitterUrl,
    } = props;

    return (
        <div className={className}>
            <span className={styles.socialMediaLabel}>
                {label}
            </span>
            {!!linkedInUrl && (
                <A
                    href={linkedInUrl}
                    native
                >
                    <img
                        alt="linkedin"
                        className={styles.socialMediaLogo}
                        src={LINKEDIN_LOGO_URL}
                    />
                </A>
            )}
            {!!twitterUrl && (
                <A
                    href={twitterUrl}
                    native
                >
                    <img
                        alt="twitter"
                        className={styles.socialMediaLogo}
                        src={TWITTER_LOGO_URL}
                    />
                </A>
            )}
        </div>
    );
}

function FoundersSection(props) {
    const {
        t,
    } = props;

    return (
        <PageSection
            aria-labelledby="founders-section"
            className={styles.foundersSection}
            layoutClassName={styles.foundersSectionLayout}
        >
            <SectionTitle id="founders-section">
                {t('about-us-founders-title')}
            </SectionTitle>
            {FOUNDER_DATA.map((data) => (
                <div
                    className={classNames(
                        styles.founderText,
                        { [styles.mirrored]: data.isMirrored },
                    )}
                    key={data.founderLabel}
                >
                    <img
                        alt=""
                        className={classNames(
                            styles.foundersImage,
                            { [styles.mirrored]: data.isMirrored },
                        )}
                        src={data.founderImage}
                    />
                    <MarkdownContent
                        className={classNames(
                            styles.foundersDescription,
                            { [styles.mirrored]: data.isMirrored },
                        )}
                    >
                        {t(data.founderDescription)}
                    </MarkdownContent>
                    <SocialMediaTag
                        className={classNames(
                            styles.socialMediaTag,
                            { [styles.mirrored]: data.isMirrored },
                        )}
                        label={t(data.founderLabel)}
                        linkedInUrl={data.linkedInUrl}
                        twitterUrl={data.twitterUrl}
                    />
                </div>
            ))}
        </PageSection>
    );
}

export {
    FoundersSection,
    SocialMediaTag,
};
export default localize(FoundersSection, ['t'], 'baseApp');
